import { ReelsContainer } from '@/containers/reels/ReelsContainer'
import { BonusRespinBoardContainer } from '@/containers/reels/BonusRespinBoardContainer'
import { ShowWinnings } from '@/containers/winnings/ShowWinnings'
import GameSignals from '@/signals/GameSignals'
import gsap from 'gsap'
import * as PIXI from 'pixi.js'
import { ContainersNames } from '@/containers/ContainersNames'
import { AnticipationContainer } from '@/containers/reels/AnticipationContainer'
import GeneralSignals from '@/signals/GeneralSignals'
import Facade from '@/Facade'
import { Orientation } from '@/modules'
import { DeviceUtils } from '@modules/src/utils/DeviceUtils'

export class MainContainer extends PIXI.Container {
    private readonly _reelsContainer: ReelsContainer
    private readonly _showWinnings: ShowWinnings
    private readonly _bonusRespinBoardContainer: BonusRespinBoardContainer
    private readonly _anticipationContainer: AnticipationContainer
    private readonly _reelsWrapper: PIXI.Container

    public constructor() {
        super()
        GameSignals.init.connect(this.onInit)
        GameSignals.completeSplashScreenState.connect(this.onSplashScreenClosed)
        GeneralSignals.orientationChanged.connect(this.onUpdateLayout)

        this._reelsContainer = new ReelsContainer()
        this._bonusRespinBoardContainer = new BonusRespinBoardContainer()
        this._anticipationContainer = new AnticipationContainer()
        this._showWinnings = new ShowWinnings()

        this._reelsWrapper = new PIXI.Container()
        this._reelsWrapper.name = ContainersNames.REELS_WRAPPER
        this._reelsWrapper.addChild(this._reelsContainer)
        this._reelsWrapper.addChild(this._bonusRespinBoardContainer)
        this._reelsWrapper.addChild(this._anticipationContainer)
        this._reelsWrapper.addChild(this._showWinnings)
        this.addChild(this._reelsWrapper)
        // this.rect = new PIXI.Graphics()
        // this.rect.x = -58
        // this.rect.y = -53
        // this.rect.beginFill(0, 0.001)
        // this.rect.lineStyle(1, 0xff0000)
        // this.rect.drawRect(5, 5, 200, 200)
        // this.rect.interactive = true
        // this.rect.buttonMode = true
        // this.addChild(this.rect)
    }

    private onInit = () => {
        gsap.to(this, {
            duration: 1,
            alpha: 1,
            ease: 'power1.in',
            onComplete: () => {
                this.onUpdateLayout(Facade.orientation)
            },
        })
    }

    private onSplashScreenClosed = () => {
        this.alpha = 0
        this.visible = true

        gsap.to(this, {
            duration: 2,
            alpha: 1,
        })
    }

    private onUpdateLayout = (orientation: string) => {
        switch (orientation) {
            case Orientation.LANDSCAPE:
                this._reelsWrapper.position.set(
                    DeviceUtils.isMobileDevice() ? -516.5 : -514,
                    DeviceUtils.isMobileDevice() ? -378 : -382
                )
                this._reelsWrapper.scale.set(1)
                break
            case Orientation.PORTRAIT:
                this._reelsWrapper.scale.set(1.04)
                this._reelsWrapper.position.set(-535, -497)
                break
        }
    }
}
